import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/** Own profile at /profile — redirects to /fan/:uid */
export function OwnUserProfile() {
  const { currentUser } = useAuth();
  if (!currentUser) return <Navigate to="/welcome?auth=signin" replace />;
  return <Navigate to={`/fan/${currentUser.uid}`} replace />;
}

/** Legacy alias — redirects to FanProfile route */
export function OtherUserProfile() {
  const { userId } = useParams();
  return <Navigate to={`/fan/${userId}`} replace />;
}

export default OwnUserProfile;
